module.exports = __webpack_public_path__ + "static/media/new_ideas.871356c1.svg";